import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";
import styles from "./CustomSelect.module.scss";
/**
 * @deprecated use Select from @jti/ui instead
 */
const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;
/**
 * @deprecated use Select from @jti/ui instead
 */
export const DEPRECATED_CustomSelect = (params) => {
    const { control } = useFormContext();
    return (_jsx(ConditionalWrapper, { condition: !!params.dataTestId, wrapper: (children) => _jsx("div", { "data-testid": params.dataTestId, children: children }), children: _jsx(Controller, { render: ({ field }) => (_jsx(Select, { ...field, inputId: params.inputId, className: styles.container, classNamePrefix: "react-select", ...params, theme: (theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: "black",
                    },
                    outline: "none",
                    boxShadow: "none",
                }) })), rules: params.validation, name: params.name, control: control, defaultValue: params.defaultValue }) }));
};
//# sourceMappingURL=DEPRECATED_CustomSelect.js.map